/**
 * DocumentTemplateType - Codes for pdf template types
 */
export enum PdfTemplateType {
	KOSTENVORANSCHLAG = "kv", // quotation
	LIEFERSCHEIN = "ls", // delivery note
	RECHNUNG = "rg", // invoice
	RECHNUNGSDOPPEL = "rg_doppel", // duplicate invoice
	ZAHLUNGSERINNERUNG = "zahlungserinnerung", // reminder
	ERSTE_MAHNUNG = "mahnung_1", // first notice
	FOLGEMAHNUNG = "mahnung_2", // second notice
	LETZTE_MAHNUNG = "letzte_mahnung", // final notice (highest configured stage)
	// ARBEITSVORBEREITUNG = "avor", // job preparation
	// PATIENTENPASS = "pp", // patient pass
	BARZAHLUNGSQUITTUNG = "bar", // cash payment receipt
	KARTENZAHLUNGSQUITTUNG = "karte", // card payment receipt
	AKONTORECHNUNG = "akonto", // advance payment invoice
	GUTSCHRIFT = "gs", // credit note
	AUFTRAGSBLATT = "auftragsblatt", // order sheet
	ETIK_AUFTRAG = "etik_auftrag", // job order label / sticker
	// FAKTURAJOURNAL = "fakturajournal", // invoice journal
	SAMMELRECHNUNG = "srg", // monthly invoice
}

export enum XmlTemplateType {
	KOSTENVORANSCHLAG_XML = "kv_xml",
	LIEFERSCHEIN_XML = "ls_xml",
	GERMAN_XML = "german_xml",
}
